import { createSlice } from "@reduxjs/toolkit";

const placeCartSlice = createSlice({
  name: "placeCart",
  initialState: {
    items: [],
    totalPrice: 0,
    quickOrderObject: {
      placeId: "",
      placeName: "",
      imageID: "",
      imageUrl: "",
      details: [],
      totalPrice: 0,
    },
    defaultTicketType: 1,
    selectedTicketCounter: 0,
    countriesProvincesInfo: [],
  },
  reducers: {
    reset(state) {
      state.quickOrderObject = {
        placeId: "",
        placeName: "",
        imageID: "",
        imageUrl: "",
        details: [],
        totalPrice: 0,
      };
      state.defaultTicketType = 1;
    },
    setDefaultTicketType(state, action) {
      state.defaultTicketType = action.payload;
    },
    setSelectedTicketCounter(state, action) {
      state.selectedTicketCounter = action.payload;
    },
    setDefaultTicketTypeAndTicketCounter(state, action) {
      state.selectedTicketCounter = action.payload.counter;
      state.defaultTicketType = action.payload.ticketType;
    },
    checkAll(state) {
      const currentItems = JSON.parse(JSON.stringify(state.items));

      currentItems.forEach((el) => (el.isSelected = true));
      let totalPrice = 0;
      currentItems.forEach((el) => {
        if (el.isSelected) {
          totalPrice += el.totalPrice;
        }
      });
      state.items = currentItems;
      state.totalPrice = totalPrice;
    },
    resetCart(state) {
      state.items = [];
      state.totalPrice = 0;
    },
    resetSelect(state) {
      const currentItems = JSON.parse(JSON.stringify(state.items));

      currentItems.forEach((el) => (el.isSelected = false));
      state.items = currentItems;
      state.totalPrice = 0;
    },
    getUserCart(state, action) {
      const currentItems = JSON.parse(JSON.stringify(action.payload.data));
      let totalPrice = 0;
      currentItems.forEach((el) => {
        if (el.isSelected) {
          totalPrice += el.totalPrice;
        }
      });
      state.items = currentItems;
      state.totalPrice = totalPrice;
    },
    selectItemToPay(state, action) {
      const selectedTicket = action.payload.ticketTypeId;
      const isChecked = action.payload.isChecked;
      const currentItems = JSON.parse(
        JSON.stringify(
          state.items
        )
      );
      currentItems.forEach((el) => {
        if (el.ticketTypeId === selectedTicket && isChecked) {
          el.isSelected = true;
        }

        if (el.ticketTypeId === selectedTicket && !isChecked) {
          el.isSelected = false;
        }
      });

      let totalPrice = 0;
      currentItems.forEach((el) => {
        if (el.isSelected) {
          totalPrice += el.totalPrice;
        }
      });
      state.items = currentItems;
      state.totalPrice = totalPrice;
    },
    removeCartItem(state, action) {
      const currentItems = JSON.parse(JSON.stringify(state.items));
      const remainItems = currentItems.filter(
        (el) => el.cartId !== +action.payload
      );
      let totalPrice = 0;
      remainItems.forEach((el) => {
        if (el.isSelected) {
          totalPrice += el.totalPrice;
        }
      });
      state.items = remainItems;
      state.totalPrice = totalPrice;
    },
    addItemToCart(state, action) {
      const selectedPlace = { ...action.payload.selectedPlace };
      let selectedQuickPlace;
      const currentItems = [...state.items];

      let existingPlace = currentItems.find(
        (el) => el.ticketTypeId === selectedPlace.ticketTypeId
      );
      if (existingPlace) {
        existingPlace.totalPrice = 0;
        existingPlace.details.forEach((el) => {
          if (el.custommerTypeId === 1) {
            el.quantity = el.quantity + 1;
          }
          existingPlace.totalPrice =
            existingPlace.totalPrice + el.price * el.quantity;
        });
      } else {
        selectedQuickPlace = {
          ticketTypeId: selectedPlace.ticketTypeId,
          placeId: selectedPlace.id,
          placeName: selectedPlace.title,
          placeNameEn: selectedPlace.enName,
          imageID: selectedPlace.imageID,
          imageUrl: selectedPlace.imageUrl,
          details: [],
          totalPrice: 0,
          isSelected: true,
          cartId: selectedPlace.cartId || 0,
          listPlaceName: selectedPlace.listPlaceName,
          typeValue: selectedPlace.typeValue,
          festivalEventTimeId: selectedPlace.festivalEventTimeId || null,
          festivalEventTimeInfo: selectedPlace.festivalEventTimeInfo || null,
        };

        const vTemp = selectedPlace.priceDetail || [];

        vTemp.forEach((el) => {
          const item = { ...el };
          item.quantity = 0;
          item.identityInfo = [];
          item.quantityDetail = [];
          selectedQuickPlace.details.push(item);
        });
        selectedQuickPlace.details.forEach((el) => {
          if (el.custommerTypeId === 1) {
            el.quantity = el.quantity + 1;
            el.identityInfo.push({
              id: el.identityInfo.length,
              priorType: 0,
            });
          }
          selectedQuickPlace.totalPrice =
            selectedQuickPlace.totalPrice + el.price * el.quantity;
        });
        currentItems.push(selectedQuickPlace);
      }
      let totalPrice = 0;
      currentItems.forEach((el) => {
        if (el.isSelected) {
          totalPrice += el.totalPrice;
        }
      });
      state.items = currentItems;
      state.totalPrice = totalPrice;
    },

    turningQuantity(state, action) {
      const { custommerTypeId, count, ticketTypeId } = action.payload;
      const currentItems = [...state.items];
      let existingPlace = currentItems.find(
        (el) => el.ticketTypeId === ticketTypeId
      );
      let currentType = existingPlace.details.find(
        (el) => el.custommerTypeId === custommerTypeId
      );

      if (count < 0) {
        if (currentType.quantity > 0) {
          currentType.quantity = currentType.quantity + count;
          currentType.identityInfo.pop();
          existingPlace.totalPrice =
            existingPlace.totalPrice + currentType.price * count;
        }
      } else {
        currentType.quantity = currentType.quantity + count;
        currentType.identityInfo.push({
          id: currentType.identityInfo.length,
          priorType: 0,
        });
        existingPlace.totalPrice =
          existingPlace.totalPrice + currentType.price * count;
      }
      let totalPrice = 0;
      currentItems.forEach((el) => {
        if (el.isSelected) {
          totalPrice += el.totalPrice;
        }
      });
      state.items = currentItems;
      state.totalPrice = totalPrice;
    },
    increaseAdultQuantity(state, action) {
      const placeId = action.payload.placeId;
      const existingItem = state.items.find((item) => item.id === placeId);
      if (!existingItem) return;
      existingItem.adultQuantity += 1;

      let mPrice = 0;
      state.items.forEach((el) => {
        mPrice =
          mPrice +
          el.adultQuantity * el.adultPrice +
          el.childrenQuantity * el.childrenPrice;
      });
      state.totalPrice = mPrice;
    },
    decreaseAdultQuantity(state, action) {
      const placeId = action.payload.placeId;
      const existingItem = state.items.find((item) => item.id === placeId);
      if (!existingItem) return;
      if (existingItem.adultQuantity === 0) return;
      existingItem.adultQuantity -= 1;
      let mPrice = 0;
      state.items.forEach((el) => {
        mPrice =
          mPrice +
          el.adultQuantity * el.adultPrice +
          el.childrenQuantity * el.childrenPrice;
      });
      state.totalPrice = mPrice;
    },
    increaseChildrenQuantity(state, action) {
      const placeId = action.payload.placeId;
      const existingItem = state.items.find((item) => item.id === placeId);
      if (!existingItem) return;
      existingItem.childrenQuantity += 1;
      let mPrice = 0;
      state.items.forEach((el) => {
        mPrice =
          mPrice +
          el.adultQuantity * el.adultPrice +
          el.childrenQuantity * el.childrenPrice;
      });
      state.totalPrice = mPrice;
    },
    decreaseChildrenQuantity(state, action) {
      const placeId = action.payload.placeId;
      const existingItem = state.items.find((item) => item.id === placeId);
      if (!existingItem) return;
      if (existingItem.childrenQuantity === 0) return;
      existingItem.childrenQuantity -= 1;
      let mPrice = 0;
      state.items.forEach((el) => {
        mPrice =
          mPrice +
          el.adultQuantity * el.adultPrice +
          el.childrenQuantity * el.childrenPrice;
      });
      state.totalPrice = mPrice;
    },

    updateChildrenQuantity(state, action) {
      const placeId = action.payload.placeId;
      const existingItem = state.items.find((item) => item.id === placeId);
      if (!existingItem) return;
      existingItem.childrenQuantity = action.payload.count;
      let mPrice = 0;
      state.items.forEach((el) => {
        mPrice =
          mPrice +
          el.adultQuantity * el.adultPrice +
          el.childrenQuantity * el.childrenPrice;
      });
      state.totalPrice = mPrice;
    },

    updateAdultQuantity(state, action) {
      const placeId = action.payload.placeId;
      const existingItem = state.items.find((item) => item.id === placeId);
      if (!existingItem) return;
      existingItem.adultQuantity = action.payload.count;
      let mPrice = 0;
      state.items.forEach((el) => {
        mPrice =
          mPrice +
          el.adultQuantity * el.adultPrice +
          el.childrenQuantity * el.childrenPrice;
      });
      state.totalPrice = mPrice;
    },
    quickOrderTuningQuantity(state, action) {
      const { count, custommerTypeId } = action.payload;
      const currentSelectedQuickPlace = JSON.parse(
        JSON.stringify({ ...state.quickOrderObject })
      );
      currentSelectedQuickPlace.totalPrice = 0;
      currentSelectedQuickPlace.details.forEach((el) => {
        if (el.custommerTypeId === custommerTypeId) {
          if (count < 0) {
            el.identityInfo.pop();
          }
          if (count > 0) {
            el.identityInfo.push({
              id: `${custommerTypeId}_${el.identityInfo.length}`,
              priorType: 0,
            });
          }
          el.quantity = el.quantity + count;
          if (el.quantity < 0) {
            el.quantity = 0;
          }
        }

        currentSelectedQuickPlace.totalPrice =
          currentSelectedQuickPlace.totalPrice + el.price * el.quantity;
      });

      state.quickOrderObject = { ...currentSelectedQuickPlace };
    },
    quickOrderChangeQuantity(state, action) {
      const { count, custommerTypeId } = action.payload;
      const currentSelectedQuickPlace = JSON.parse(
        JSON.stringify({ ...state.quickOrderObject })
      );
      currentSelectedQuickPlace.totalPrice = 0;
      currentSelectedQuickPlace.details.forEach((el) => {
        if (el.custommerTypeId === custommerTypeId) {
          el.quantity = count;
        }

        currentSelectedQuickPlace.totalPrice =
          currentSelectedQuickPlace.totalPrice + el.price * el.quantity;
      });

      state.quickOrderObject = { ...currentSelectedQuickPlace };
    },
    initQuickOrder(state, action) {
      const selectedPlace = { ...action.payload.selectedPlace };
      const selectedQuickPlace = {
        ticketTypeId: selectedPlace.ticketTypeId,
        placeId: selectedPlace.id,
        placeName: selectedPlace.title,
        placeNameEn: selectedPlace.enName,
        imageID: selectedPlace.imageID,
        imageUrl: selectedPlace.imageUrl,
        details: [],
        totalPrice: 0,
      };

      const vTemp = selectedPlace.priceDetail || [];

      vTemp.forEach((el) => {
        const item = { ...el };
        item.quantity = 0;
        item.identityInfo = [];
        item.quantityDetail = [];
        selectedQuickPlace.details.push(item);
      });

      state.quickOrderObject = selectedQuickPlace;
    },
    initTourGuideTicketOrder(state, action) {
      const selectedTicket = { ...action.payload.selectedTicket };
    },
    replaceCartItem(state, action) {
      const selectedPlace = { ...action.payload.selectedPlace };
      const selectedQuickPlace = {
        ticketTypeId: selectedPlace.ticketTypeId,
        placeId: selectedPlace.id,
        placeName: selectedPlace.title,
        placeNameEn: selectedPlace.enName,
        imageID: selectedPlace.imageID,
        imageUrl: selectedPlace.imageUrl,
        details: [],
        totalPrice: 0,
      };

      const vTemp = selectedPlace.priceDetail || [];

      const currentSelectedQuickPlace = JSON.parse(
        JSON.stringify({ ...state.quickOrderObject })
      );

      vTemp.forEach((el) => {
        const item = { ...el };

        item.quantity = 0;
        item.identityInfo = [];
        item.quantityDetail = [];
        currentSelectedQuickPlace.details.forEach((subel) => {
          if (subel.custommerTypeId === item.custommerTypeId) {
            item.quantity = subel.quantity;
          }
        });

        selectedQuickPlace.totalPrice =
          selectedQuickPlace.totalPrice + item.price * item.quantity;
        selectedQuickPlace.details.push(item);
      });
      state.quickOrderObject = selectedQuickPlace;
    },
    removeItemFromCart(state, action) {
      console.log("remove");
      const currentItems = [...state.items];
      const resultItems = [];
      currentItems.forEach((el) => {
        if (action.payload.indexOf(el.id) === -1) {
          resultItems.push(el);
        }
      });

      state.items = [...resultItems];
      let mPrice = 0;
      state.items.forEach((el) => {
        mPrice =
          mPrice +
          el.adultQuantity * el.adultPrice +
          el.childrenQuantity * el.childrenPrice;
      });
      state.totalPrice = mPrice;
    },
    removeOneItemFromCart(state, action) {
      const currentItems = JSON.parse(JSON.stringify([...state.items]));
      const resultItems = [];
      currentItems.forEach((el) => {
        if (+el.ticketTypeId !== +action.payload.placeId) {
          resultItems.push({ ...el });
        }
      });
      state.items = JSON.parse(JSON.stringify([...resultItems]));
      let mPrice = 0;
      state.items.forEach((el) => {
        el.details.forEach((subEl) => {
          mPrice += subEl.price * subEl.quantity;
        });
      });
      state.totalPrice = mPrice;
    },
    resetIdentityPaper(state, action) {
      const actionData = { ...action.payload };
      const currentItems = JSON.parse(JSON.stringify([...state.items]));
      const item = currentItems.find(
        (el) => el.ticketTypeId === actionData.ticketTypeId
      );
      const doituonguutien = item.details.find(
        (el) => el.custommerTypeId === 3
      );
      const identityPaper = doituonguutien.identityInfo.find(
        (el) => el.id === actionData.id
      );
      Object.keys(identityPaper).forEach((key) => delete identityPaper[key]);
      identityPaper.id = actionData.id;
      identityPaper.priorType = 0;
      state.items = currentItems;
    },
    addIdentityPaper(state, action) {
      const actionData = { ...action.payload };
      const currentItems = JSON.parse(JSON.stringify([...state.items]));
      const item = currentItems.find(
        (el) => el.ticketTypeId === actionData.ticketTypeId
      );
      // const pp = item.identityInfo.find((el) => el.id === actionData.id);
      const doituonguutien = item.details.find(
        (el) => el.custommerTypeId === 3
      );
      // doituonguutien.identityInfo.find((el) => el.id === actionData.id).cccd =
      // actionData.idCode;

      const identityPaper = doituonguutien.identityInfo.find(
        (el) => el.id === actionData.id
      );
      identityPaper.cccd = actionData.idCode;
      Object.assign(identityPaper, actionData);
      // console.log(identityPaper);
      // doituonguutien.identityInfo.find((el) => el.id === actionData.id) = {... actionData, cccd: actionData.idCode}
      // console.log(currentItems);
      state.items = currentItems;
    },
    updatePriorType(state, action) {
      const actionData = { ...action.payload };
      const currentItems = JSON.parse(JSON.stringify([...state.items]));
      const item = currentItems.find(
        (el) => el.ticketTypeId === actionData.ticketTypeId
      );
      const doituonguutien = item.details.find(
        (el) => el.custommerTypeId === 3
      );
      const identityPaper = doituonguutien.identityInfo.find(
        (el) => el.id === actionData.id
      );
      identityPaper.priorType = actionData.priorType;
      state.items = currentItems;
    },
    updateFullname(state, action) {
      const actionData = { ...action.payload };
      const currentItems = JSON.parse(JSON.stringify([...state.items]));
      const item = currentItems.find(
        (el) => el.ticketTypeId === actionData.ticketTypeId
      );
      const doituonguutien = item.details.find(
        (el) => el.custommerTypeId === 3
      );
      const identityPaper = doituonguutien.identityInfo.find(
        (el) => el.id === actionData.id
      );
      identityPaper.personName = actionData.personName;
      state.items = currentItems;
    },
    updateIdNumber(state, action) {
      const actionData = { ...action.payload };
      const currentItems = JSON.parse(JSON.stringify([...state.items]));
      const item = currentItems.find(
        (el) => el.ticketTypeId === actionData.ticketTypeId
      );
      const doituonguutien = item.details.find(
        (el) => el.custommerTypeId === 3
      );
      const identityPaper = doituonguutien.identityInfo.find(
        (el) => el.id === actionData.id
      );
      identityPaper.idCode = actionData.idCode;
      state.items = currentItems;
    },
    updateAddress(state, action) {
      const actionData = { ...action.payload };
      const currentItems = JSON.parse(JSON.stringify([...state.items]));
      const item = currentItems.find(
        (el) => el.ticketTypeId === actionData.ticketTypeId
      );
      const doituonguutien = item.details.find(
        (el) => el.custommerTypeId === 3
      );
      const identityPaper = doituonguutien.identityInfo.find(
        (el) => el.id === actionData.id
      );
      identityPaper.residencePlace = actionData.residencePlace;
      state.items = currentItems;
    },
    setCountriesProvincesInfo(state, action) {
      state.countriesProvincesInfo = action.payload;
    },
    setFestivalEventTime(state, action) {
      const { ticketTypeId, festivalEventTimeId, festivalEventTimeInfo } =
        action.payload;
      const currentItems = JSON.parse(JSON.stringify([...state.items]));
      const item = currentItems.find(
        (el) => +el.ticketTypeId === +ticketTypeId
      );
      if (!item) return;
      item.festivalEventTimeId = festivalEventTimeId
        ? +festivalEventTimeId
        : null;
      item.festivalEventTimeInfo = festivalEventTimeInfo || null;
      state.items = currentItems;
    },
    resetCountriesProvincesInfo(state) {
      state.countriesProvincesInfo = [];
    },
  },
});

export const placeCartActions = placeCartSlice.actions;

export default placeCartSlice;
